import { render, staticRenderFns } from "./BankVerification.vue?vue&type=template&id=321c8277&scoped=true"
import script from "./BankVerification.vue?vue&type=script&lang=js"
export * from "./BankVerification.vue?vue&type=script&lang=js"
import style0 from "./BankVerification.vue?vue&type=style&index=0&id=321c8277&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321c8277",
  null
  
)

export default component.exports